
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail/home/customer-information",
      function () {
        return require("private-next-pages/retail/home/customer-information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail/home/customer-information"])
      });
    }
  